/*
* @Author: Gang Jiang
* @Date: 2024-11-25 15:26:36
* @Last Modified by: Gang Jiang
* @Last Modified time: 2025-03-03 09:45:31
*/
<template>
  <div class="publisher">
    <!-- <div class="left"> -->
      <div style="position: relative;">
      <left-menu :menus="menu" :bottomEntries="bottomEntries" ref="leftMenuRef"/>
      <div @click="toggleCollapsed" class="toggle-menu">
      <svg class="icon" aria-hidden="true">
        <use :xlink:href="'#icon-' + (collapsed ? 'zhankai' : 'shouqi')" />
      </svg>
    </div>
    </div>
    <!-- </div> -->
    <div class="right">
      <top-bar>
        <template #title>
          <p style="margin: 0 10px">Welcome to ArtemisAds</p>
        </template>
        <template #status v-if="store.userInfo.reviewStatus === 'Pending'">
          <a-tag class="cus-tag" color="warning" style="">Account Pending Approval</a-tag>
        </template>
      </top-bar>
      <div class="content">
        <div class="min-height">
          <router-view />
        </div>
        <Footer />
      </div>
    </div>
  </div>
</template>

<script setup lang="jsx">
import { h, ref, reactive, onBeforeMount } from 'vue'
import topBar from '../../components/topBar.vue'
import Footer from '../../components/Footer.vue'
import LeftMenu from '../../components/LeftMenu.vue'
import Icon from '~/components/Icon.vue'
import { useUserInfoStore } from '~/storeData/index'
import { useSystemStore } from '@/storeData/system'
const systemStore = useSystemStore()
const store = useUserInfoStore()

let menu = []
const defaultMenu = reactive([
  {
    key: '/publisher/dashboard',
    icon: () =>
      h('svg', { class: 'icon', 'aria-hidden': 'true' }, [
        h('use', { 'xlink:href': '#icon-home' }),
      ]),
    routeName: 'dashboard',
    title: '',
    label: 'Dashboard',
  },
  {
    key: '/publisher/products',
    label: 'Products Catalogue',
    icon: () => h('i', { class: 'iconfont icon-shangpin' }),
    routeName: 'products',
  },
  {
    key: '/publisher/brands',
    label: 'Brands Catalogue',
    routeName: 'brands',
    icon: () => h('i', { class: 'iconfont icon-pinpai' }),
  },
  {
    key: store.userInfo.cpcEnabled == 'Y' ? '/publisher/campaigns' : '',
    label: 'Cost-Per-Click',
    routeName: 'campaigns',
    icon: () => h('svg', { class: 'icon', 'aria-hidden': 'true' },
      [h('use', { 'xlink:href': '#icon-a-Frame1912057478' })]),
    children: [
      {
        routeName: 'campaigns-index',
        key: '/publisher/campaigns/index',
        preKey: '/publisher/campaigns',
        label: 'CPC Campaigns',
        title: 'CPC Campaigns',
      },
      {
        routeName: 'campaigns-myCampaigns',
        key: '/publisher/campaigns/myCampaigns',
        preKey: '/publisher/campaigns',
        label: 'My Campaigns',
        title: 'My Campaigns',
      },
      {
        routeName: 'campaigns-upload',
        key: '/publisher/campaigns/upload',
        preKey: '/publisher/campaigns',
        label: 'Upload Reports',
        title: 'Upload Reports',
      },
    ]
  },
  {
    key: '/publisher/links',
    label: <div class="reports-beta">Links</div>,
    icon: () => h('i', { class: 'iconfont icon-lianjie' }),
    children: [
      {
        label: 'Brand Links',
        title: 'Brand',
        routeName: 'links-brand',
        preKey: '/publisher/links',
        key: '/publisher/links/brand',
      },
      {
        label: 'Product Links',
        title: 'Product',
        routeName: 'links-product',
        preKey: '/publisher/links',
        key: '/publisher/links/product',
      },
    ]
  },
  {
    key: '/publisher/reports',
    icon: () => h('svg', { class: 'icon', 'aria-hidden': 'true' },
      [h('use', { 'xlink:href': '#icon-chart' })]),
    title: '',
    label: <div class="reports-beta">Reports</div>,
    children: [
      {
        routeName: 'reports-performance',
        key: '/publisher/reports/performance',
        preKey: '/publisher/reports',
        label: 'Performance',
        title: 'Performance',
      },
      {
        preKey: '/publisher/reports',
        routeName: 'reports-product',
        key: '/publisher/reports/product',
        label: 'Product',
        title: 'Product',
      },
      {
        preKey: '/publisher/reports',
        routeName: 'reports-brand',
        key: '/publisher/reports/brand',
        label: 'Brand',
        title: 'Brand',
      },
      {
        preKey: '/publisher/reports',
        routeName: 'reports-trackingId',
        key: '/publisher/reports/trackingId',
        label: 'Tracking ID',
        title: 'Tracking ID',
      }
    ]
  },
  {

    routeName: 'settings-paidPlacement',
    icon: () => h('svg', { class: 'icon', 'aria-hidden': 'true' },
      [h('use', { 'xlink:href': '#icon-a-PaidPlacement' })]),
    key: '/publisher/settings/paidPlacement',
    label: <div class="reports-beta-tag">
      Paid Placement
      <div class="tag-new">
        <Icon name="Tag-New" class="icon" />
      </div>
    </div>,
    title: 'Paid Placement',
    children: [
      {
        preKey: '/publisher/settings/paidPlacement',
        routeName: 'settings-paidPlacement-campaigns',
        key: '/publisher/settings/paidPlacement/campaigns',
        label: 'Campaigns',
        title: 'Campaigns',
      },
      {
        preKey: '/publisher/settings/paidPlacement',
        routeName: 'settings-paidPlacement-placement',
        key: '/publisher/settings/paidPlacement/placement',
        label: 'Placements',
        title: 'Placements',
      },
    ]
  },
  {
    key: '/publisher/settings',
    icon: () =>
      h('svg', { class: 'icon', 'aria-hidden': 'true' }, [
        h('use', { 'xlink:href': '#icon-a-shezhi2' }),
      ]),
    label: 'Settings',
    children: [
      {
        routeName: 'settings-profile',
        key: '/publisher/settings/profile',
        preKey: '/publisher/settings',
        label: 'Profile',
        title: 'Profile',
      },
      {
        preKey: '/publisher/settings',
        routeName: 'settings-open-api',
        key: '/publisher/settings/open-api',
        label: 'Open API',
        title: 'Open API',
      },
      {

        key: '/publisher/settings/users-permissions',
        preKey: '/publisher/settings',
        routeName: 'settings-users-permissions',
        label: 'Users & Permissions',
        title: 'Users & Permissions',
      },
      {
        preKey: '/publisher/settings',
        routeName: 'settings-tracking-ids',
        key: '/publisher/settings/tracking-ids',
        label: 'Tracking IDs',
        title: 'Tracking IDs',
      },
      {
        preKey: '/publisher/settings',
        routeName: 'settings-associateTags',
        key: '/publisher/settings/associateTags',
        label: 'Amazon StoreID',
        title: 'Amazon StoreID',
      },
    ]
  },
  {
    key: '/publisher/finance',
    icon: () => h('svg', { class: 'icon', 'aria-hidden': 'true' },
      [h('use', { 'xlink:href': '#icon-yinhangka' })]),
    title: '',
    label: <div class="reports-beta">Finance</div>,
    children: [
      {
        routeName: 'finance-payments',
        key: '/publisher/finance/payments',
        preKey: '/publisher/finance',
        label: 'Payments',
        title: 'Payments',
      },
    ]
  },
  {
    key: store.userInfo.associateEnabled == 'Y' ? '/publisher/associateCentral' : '',
    icon: () => h('svg', { class: 'icon', 'aria-hidden': 'true' },
      [h('use', { 'xlink:href': '#icon-lianmengyingxiao' })]),
    title: '',
    label: <div class="reports-beta-tag">
      Associate Central
      <div class="tag-new">
        <Icon name="Tag-New" class="icon" />
      </div>
    </div>,
    routeName: 'associateCentral',
    children: [
      {
        routeName: 'associateCentral-uploadReports',
        key: '/publisher/associateCentral/uploadReports',
        preKey: '/publisher/associateCentral',
        label: 'Upload Reports',
        title: 'Upload Reports'
      },
      {
        routeName: 'associateCentral-associateBrands',
        key: '/publisher/associateCentral/associateBrands',
        preKey: '/publisher/associateCentral',
        label: 'Associate Brands',
        title: 'Associate Brands'
      },
      {
        preKey: '/publisher/associateCentral',
        routeName: 'associateCentral-associateTags',
        key: '/publisher/associateCentral/associateTags',
        label: 'Associate StoreID & Tags',
        title: 'Associate StoreID & Tags',
      },
      {
        key: '/publisher/associateCentral/creatorConnections',
        preKey: '/publisher/associateCentral',
        routeName: 'associateCentral-creatorConnections',
        label: 'Creator Connections',
        children: [
          {
            key: '/publisher/associateCentral/creatorConnections/allCampaigns',
            preKey: '/publisher/associateCentral/creatorConnections',
            routeName: 'associateCentral-creatorConnections-allCampaigns',
            label: 'All Campaigns',
          }
        ],
      }
    ]
  },
  {
    key: '/publisher/creatorConnections',
    icon: () =>
        h('svg', { class: 'icon', 'aria-hidden': 'true' }, [
          h('use', { 'xlink:href': '#icon-lianmengyingxiao' }),
    ]),
    title: '',
    label: <div class="reports-beta-tag">
      Creator Connections
      <div class="tag-new">
        <Icon name="Tag-New" class="icon" />
      </div>
    </div>,
    routeName: 'creatorConnections',
    children: [
      {
        routeName: 'creatorConnections-allCampaigns',
        key: '/publisher/creatorConnections/allCampaigns',
        preKey: '/publisher/creatorConnections',
        label: 'All Campaigns',
        title: 'All Campaigns',
      },
      {
        routeName: 'creatorConnections-bonusPrograms',
        key: '/publisher/creatorConnections/bonusPrograms',
        preKey: '/publisher/creatorConnections',
        label: 'Bonus Programs',
        title: 'Bonus Programs',
      },
      {
        preKey: '/publisher/creatorConnections',
        routeName: 'creatorConnections-associateTags',
        key: '/publisher/creatorConnections/associateTags',
        label: 'Amazon StoreID',
        title: 'Amazon StoreID',
      },
    ]
  }
])
const collapsed = ref(false)
const leftMenuRef = ref(null)
const bottomEntries = [
  {
    key: '/publisher/referral',
    icon: () =>
      h('svg', { class: 'icon', 'aria-hidden': 'true' }, [
        h('use', { 'xlink:href': '#icon-zuanshi' }),
      ]),
    routeName: 'referral',
    title: 'Refer Your Friends',
    label: 'Refer Your Friends',
  },
  {
    key: 'contact-us',
    icon: () =>
      h('svg', { class: 'icon icon-contact-us', 'aria-hidden': 'true' }, [
        h('use', { 'xlink:href': '#icon-youjian' }),
      ]),
    label: 'Contact Us',
  },
  {
    key: '/help',
    icon: () =>
      h('svg', { class: 'icon icon-help', 'aria-hidden': 'true' }, [
        h('use', { 'xlink:href': '#icon-wenhao' }),
      ]),
    routeName: 'help',
    label: 'Need Help?',
  },
]
function setUserMenus (menus) {
  if (menus) {
    menu = menus.children.map(item => {
      for (let i = 0; i < defaultMenu.length; i++) {
        if (item.path === defaultMenu[i].key) {
          if (defaultMenu[i].children) {
            const children = []

            for (let j = 0; j < item.children?.length; j++) {
              for (let k = 0; k < defaultMenu[i].children.length; k++) {
                if (item.children[j].path === defaultMenu[i].children[k].key) {
                  children.push(defaultMenu[i].children[k])
                  break
                }
              }
            }

            defaultMenu[i].children = children
          }

          return defaultMenu[i]
        }
      }
    })
  } else {
    menu = defaultMenu
  }
  menu = (menu || []).filter((item) => item && item.key && item.label)
}
// console.log(store.userInfo,'store.userInfo')
const toggleCollapsed = () => {
  collapsed.value = !collapsed.value
  leftMenuRef.value.toggleCollapsed()
}
if (store.userInfo.associateEnabled == 'Y') {
  systemStore.setProgramConfig([
    { key: '0', label: 'Attribution', disabled: false },
    { key: '1', label: 'Associate', disabled: false },
  ])
  systemStore.setProgramConfigLink([
    { key: '0', label: 'Attribution Link', disabled: false },
    { key: '1', label: 'Associate Link', disabled: false },
  ])
} else {
  systemStore.setProgramConfig([
    { key: '0', label: 'Attribution', disabled: false },
  ])
  systemStore.setProgramConfigLink([
    { key: '0', label: 'Attribution Link', disabled: false },
  ])
}
// console.log(store.userInfo,'store.userInfo.menus')
setUserMenus(store.userInfo.menus)
onBeforeMount(() => {
  systemStore.setPageType('publisher')
})
</script>
<style>
.toggle-menu {
    top: 10px;
    z-index: 999;
    width: 24px;
    right: -24px;
    height: 28px;
    cursor: pointer;
    position: absolute;
    background: #ffffff;
    border: 1px solid var(--border-4);
    box-shadow: 0 1px 0 0 var(--box-shadow-2);
    border-radius: 0 8px 8px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--dark-3);

    .icon {
      font-size: 12px;
      font-weight: 600;
    }

    &:hover {
      color: var(--dark-3);
      background-color: var(--bg-gray-1);
      border-color: var(--border-1);
    }

    &:active {
      color: var(--dark-2);
      background-color: var(--bg-gray-2);
      border-color: var(--bg-gray-7);
    }
  }
:deep(.ant-tour-arrow::before) {
  clip-path: path('M 0 8 A 4 4 0 0 0 2.82842712474619 6.82842712474619 L 6.585786437626905 3.0710678118654755 A 2 2 0 0 1 9.414213562373096 3.0710678118654755 L 13.17157287525381 6.82842712474619 A 4 4 0 0 0 16 8 Z') !important;
}
.artmisads-button.artmisads-default{
  border: 1px solid var(--border-1) !important;
}
</style>
<style lang="less" scoped>
:deep(.icon-lianjie) {
  font-size: 24px !important;
}

:deep(.ant-menu-title-content) {
  overflow: visible !important;

  .reports-beta-tag {
    position: relative;

    .tag-new {
      position: absolute;
      top: -10px;
      left: -25px;
      z-index: 10;

      .icon {
        font-size: 24px;
      }
    }
  }
}

.publisher {
  display: flex;
  width: 100dvw;
  height: 100dvh;
  overflow: hidden;
  // min-width: 1200px;
  background: #f4f2f7;

  :deep(label) {
    font-weight: normal;
  }

  .cus-tag {
    background-color: #fffbe6;
    border: 1px solid #ffe58f;
  }

  :deep(.content-wrapper) {
    display: flex;
    border-radius: 8px;
    padding: 16px 16px 0;
    background-color: #fff;
    box-shadow: var(--section-box-shadow-6);
  }

  .right {
    flex: 1;
    display: flex;
    min-width: 0;
    flex-direction: column;
  }

  .content {
    padding: 0 16px;
    margin-top: 1px;
    overflow-y: auto;
    background: #f3f2f7;
    min-height: calc(100% - 48px);
  }

  .min-height {
    min-height: calc(100% - 73px);
  }
}
</style>